import { Tabs, useSegments } from "expo-router";
import { PlatformPressable } from "@react-navigation/elements";
import { View, StyleSheet } from "react-native";
import { BlurView } from "expo-blur";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useTheme } from "@/hooks/useTheme";

const TAB_BAR_HEIGHT = 48; // Estimated tab bar height

export default function CrewHomeLayout() {
  const insets = useSafeAreaInsets();
  const { colors } = useTheme();
  const segs = useSegments();

  // Hide tab bar when viewing a specific shift
  const isShiftRoute = (segs as string[]).includes("[shift]");

  return (
    <View style={styles.container}>
      <Tabs
        screenOptions={{
          headerShown: false,
          tabBarBackground: () => <BlurView intensity={100} tint={colors.name} style={StyleSheet.absoluteFill} />,
          tabBarIcon: () => null,
          tabBarButton: (props) => <PlatformPressable {...props} />,
          tabBarLabelStyle: {
            // top: 14,
            position: "absolute",
            fontSize: 14,
          },
          tabBarStyle: {
            position: "absolute",
            top: insets.top,
            left: 0,
            right: 0,
            height: TAB_BAR_HEIGHT,
            borderBottomWidth: 0,
            elevation: 0,
            display: isShiftRoute ? "none" : "flex",
          },
        }}
      >
        <Tabs.Screen
          name="index"
          options={{
            title: "Invited",
          }}
        />
        <Tabs.Screen name="accepted" options={{ title: "Accepted" }} />
        <Tabs.Screen name="[shift]" options={{ href: null }} />
      </Tabs>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
